import { Moment } from 'moment'
import React from 'react'

import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import { LONG_DATE } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { Place } from 'tripPlanner/types/common'

type Props = {
  place: Place
  date: Moment | undefined
  time: Moment | undefined
  day?: number
}

export default function ItemLocationSummary({ place, date, time, day }: Props) {
  const timeFormat = useRegionTimeFormat()

  return (
    <div>
      {day && <BodyText variant="small">Day {day}</BodyText>}
      {!day && date && (
        <BodyText variant="small">{date.format(LONG_DATE)}</BodyText>
      )}
      <Caption variant="large" weight="bold">
        {place.name}
      </Caption>
      {time && <BodyText variant="small">{time.format(timeFormat)}</BodyText>}
    </div>
  )
}
